(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/keno-winplan-data.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/keno-winplan-data.js');
"use strict";


const keno = {
  size_0: {
    corr_1: {
      KW: 0,
      KKW: 0
    }
  },
  size_1: {
    corr_1: {
      KW: 10,
      KKW: 170
    }
  },
  size_2: {
    corr_1: {
      KKW: 40
    },
    corr_2: {
      KW: 30,
      KKW: 240
    }
  },
  size_3: {
    corr_1: {
      KKW: 25
    },
    corr_2: {
      KW: 5,
      KKW: 50
    },
    corr_3: {
      KW: 60,
      KKW: 400
    }
  },
  size_4: {
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KW: 5,
      KKW: 30
    },
    corr_3: {
      KW: 10,
      KKW: 60
    },
    corr_4: {
      KW: 120,
      KKW: 800
    }
  },
  size_5: {
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KKW: 15
    },
    corr_3: {
      KW: 5,
      KKW: 30
    },
    corr_4: {
      KW: 40,
      KKW: 150
    },
    corr_5: {
      KW: 800,
      KKW: 2500
    }
  },
  size_6: {
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KKW: 10
    },
    corr_3: {
      KW: 5,
      KKW: 15
    },
    corr_4: {
      KW: 15,
      KKW: 50
    },
    corr_5: {
      KW: 90,
      KKW: 300
    },
    corr_6: {
      KW: 1700,
      KKW: 10000
    }
  },
  size_7: {
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KKW: 10
    },
    corr_3: {
      KKW: 10
    },
    corr_4: {
      KW: 5,
      KKW: 30
    },
    corr_5: {
      KW: 50,
      KKW: 150
    },
    corr_6: {
      KW: 400,
      KKW: 1000
    },
    corr_7: {
      KW: 10000,
      KKW: 25000
    }
  },
  size_8: {
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KKW: 10
    },
    corr_3: {
      KKW: 10
    },
    corr_4: {
      KW: 5,
      KKW: 15
    },
    corr_5: {
      KW: 15,
      KKW: 30
    },
    corr_6: {
      KW: 100,
      KKW: 300
    },
    corr_7: {
      KW: 1000,
      KKW: 2000
    },
    corr_8: {
      KW: 45000,
      KKW: 130000
    }
  },
  size_9: {
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KKW: 10
    },
    corr_3: {
      KKW: 10
    },
    corr_4: {
      KKW: 10
    },
    corr_5: {
      KW: 5,
      KKW: 15
    },
    corr_6: {
      KW: 50,
      KKW: 100
    },
    corr_7: {
      KW: 250,
      KKW: 500
    },
    corr_8: {
      KW: 5000,
      KKW: 10000
    },
    corr_9: {
      KW: 250000,
      KKW: 600000
    }
  },
  size_10: {
    corr_0: {
      KW: 5
    },
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KKW: 10
    },
    corr_3: {
      KKW: 10
    },
    corr_4: {
      KKW: 10
    },
    corr_5: {
      KW: 5,
      KKW: 15
    },
    corr_6: {
      KW: 15,
      KKW: 50
    },
    corr_7: {
      KW: 100,
      KKW: 200
    },
    corr_8: {
      KW: 800,
      KKW: 1600
    },
    corr_9: {
      KW: 15000,
      KKW: 30000
    },
    corr_10: {
      KW: 1000000,
      KKW: 2000000
    }
  },
  size_11: {
    corr_1: {
      KKW: 30
    },
    corr_2: {
      KKW: 10
    },
    corr_3: {
      KKW: 10
    },
    corr_4: {
      KKW: 10
    },
    corr_5: {
      KW: 5,
      KKW: 15
    },
    corr_6: {
      KW: 10,
      KKW: 15
    },
    corr_7: {
      KW: 30,
      KKW: 100
    },
    corr_8: {
      KW: 200,
      KKW: 500
    },
    corr_9: {
      KW: 2000,
      KKW: 4000
    },
    corr_10: {
      KW: 80000,
      KKW: 160000
    },
    corr_11: {
      KW: 5000000,
      KKW: 20000000
    }
  }
};

const kenoSystem = {
  size_2: {
    m3: {
      corr_1: {
        KKW: 80
      },
      corr_2: {
        KW: 30,
        KKW: 280
      },
      corr_3: {
        KW: 90,
        KKW: 510
      }
    },
    m4: {
      corr_1: {
        KKW: 120
      },
      corr_2: {
        KW: 30,
        KKW: 320
      },
      corr_3: {
        KW: 90,
        KKW: 550
      },
      corr_4: {
        KW: 180,
        KKW: 810
      }
    },
    m5: {
      corr_1: {
        KKW: 160
      },
      corr_2: {
        KW: 30,
        KKW: 360
      },
      corr_3: {
        KW: 90,
        KKW: 590
      },
      corr_4: {
        KW: 180,
        KKW: 850
      },
      corr_5: {
        KW: 300,
        KKW: 1140
      }
    },
    m6: {
      corr_1: {
        KKW: 200
      },
      corr_2: {
        KW: 30,
        KKW: 400
      },
      corr_3: {
        KW: 90,
        KKW: 630
      },
      corr_4: {
        KW: 180,
        KKW: 890
      },
      corr_5: {
        KW: 300,
        KKW: 1180
      },
      corr_6: {
        KW: 450,
        KKW: 1500
      }
    },
    m7: {
      corr_1: {
        KKW: 240
      },
      corr_2: {
        KW: 30,
        KKW: 440
      },
      corr_3: {
        KW: 90,
        KKW: 670
      },
      corr_4: {
        KW: 180,
        KKW: 930
      },
      corr_5: {
        KW: 300,
        KKW: 1220
      },
      corr_6: {
        KW: 450,
        KKW: 1540
      },
      corr_7: {
        KW: 630,
        KKW: 1890
      }
    },
    m8: {
      corr_1: {
        KKW: 280
      },
      corr_2: {
        KW: 30,
        KKW: 480
      },
      corr_3: {
        KW: 90,
        KKW: 710
      },
      corr_4: {
        KW: 180,
        KKW: 970
      },
      corr_5: {
        KW: 300,
        KKW: 1260
      },
      corr_6: {
        KW: 450,
        KKW: 1580
      },
      corr_7: {
        KW: 630,
        KKW: 1930
      },
      corr_8: {
        KW: 840,
        KKW: 2310
      }
    },
    m9: {
      corr_1: {
        KKW: 320
      },
      corr_2: {
        KW: 30,
        KKW: 520
      },
      corr_3: {
        KW: 90,
        KKW: 750
      },
      corr_4: {
        KW: 180,
        KKW: 1010
      },
      corr_5: {
        KW: 300,
        KKW: 1300
      },
      corr_6: {
        KW: 450,
        KKW: 1620
      },
      corr_7: {
        KW: 630,
        KKW: 1970
      },
      corr_8: {
        KW: 840,
        KKW: 2350
      },
      corr_9: {
        KW: 1080,
        KKW: 2760
      }
    },
    m10: {
      corr_1: {
        KKW: 360
      },
      corr_2: {
        KW: 30,
        KKW: 560
      },
      corr_3: {
        KW: 90,
        KKW: 790
      },
      corr_4: {
        KW: 180,
        KKW: 1050
      },
      corr_5: {
        KW: 300,
        KKW: 1340
      },
      corr_6: {
        KW: 450,
        KKW: 1660
      },
      corr_7: {
        KW: 630,
        KKW: 2010
      },
      corr_8: {
        KW: 840,
        KKW: 2390
      },
      corr_9: {
        KW: 1080,
        KKW: 2800
      },
      corr_10: {
        KW: 1350,
        KKW: 3240
      }
    }
  },
  size_3: {
    m4: {
      corr_1: {
        KKW: 75
      },
      corr_2: {
        KW: 10,
        KKW: 125
      },
      corr_3: {
        KW: 75,
        KKW: 505
      },
      corr_4: {
        KW: 240,
        KKW: 1260
      }
    },
    m5: {
      corr_1: {
        KKW: 150
      },
      corr_2: {
        KW: 15,
        KKW: 225
      },
      corr_3: {
        KW: 90,
        KKW: 635
      },
      corr_4: {
        KW: 270,
        KKW: 1425
      },
      corr_5: {
        KW: 600,
        KKW: 2640
      }
    },
    m6: {
      corr_1: {
        KKW: 250
      },
      corr_2: {
        KW: 20,
        KKW: 350
      },
      corr_3: {
        KW: 105,
        KKW: 790
      },
      corr_4: {
        KW: 300,
        KKW: 1615
      },
      corr_5: {
        KW: 650,
        KKW: 2870
      },
      corr_6: {
        KW: 1200,
        KKW: 4600
      }
    },
    m7: {
      corr_1: {
        KKW: 375
      },
      corr_2: {
        KW: 25,
        KKW: 500
      },
      corr_3: {
        KW: 120,
        KKW: 970
      },
      corr_4: {
        KW: 330,
        KKW: 1830
      },
      corr_5: {
        KW: 700,
        KKW: 3125
      },
      corr_6: {
        KW: 1275,
        KKW: 4900
      },
      corr_7: {
        KW: 2100,
        KKW: 7200
      }
    },
    m8: {
      corr_1: {
        KKW: 525
      },
      corr_2: {
        KW: 30,
        KKW: 675
      },
      corr_3: {
        KW: 135,
        KKW: 1175
      },
      corr_4: {
        KW: 360,
        KKW: 2070
      },
      corr_5: {
        KW: 750,
        KKW: 3405
      },
      corr_6: {
        KW: 1350,
        KKW: 5225
      },
      corr_7: {
        KW: 2205,
        KKW: 7575
      },
      corr_8: {
        KW: 3360,
        KKW: 10500
      }
    },
    m9: {
      corr_1: {
        KKW: 700
      },
      corr_2: {
        KW: 35,
        KKW: 875
      },
      corr_3: {
        KW: 150,
        KKW: 1405
      },
      corr_4: {
        KW: 390,
        KKW: 2335
      },
      corr_5: {
        KW: 800,
        KKW: 3710
      },
      corr_6: {
        KW: 1425,
        KKW: 5575
      },
      corr_7: {
        KW: 2310,
        KKW: 7975
      },
      corr_8: {
        KW: 3500,
        KKW: 10955
      },
      corr_9: {
        KW: 5040,
        KKW: 14560
      }
    },
    m10: {
      corr_1: {
        KKW: 900
      },
      corr_2: {
        KW: 40,
        KKW: 1100
      },
      corr_3: {
        KW: 165,
        KKW: 1660
      },
      corr_4: {
        KW: 420,
        KKW: 2625
      },
      corr_5: {
        KW: 850,
        KKW: 4040
      },
      corr_6: {
        KW: 1500,
        KKW: 5950
      },
      corr_7: {
        KW: 2415,
        KKW: 8400
      },
      corr_8: {
        KW: 3640,
        KKW: 11435
      },
      corr_9: {
        KW: 5220,
        KKW: 15100
      },
      corr_10: {
        KW: 7200,
        KKW: 19440
      }
    }
  },
  size_4: {
    m5: {
      corr_1: {
        KKW: 120
      },
      corr_2: {
        KW: 15,
        KKW: 120
      },
      corr_3: {
        KW: 35,
        KKW: 185
      },
      corr_4: {
        KW: 160,
        KKW: 990
      },
      corr_5: {
        KW: 600,
        KKW: 3320
      }
    },
    m6: {
      corr_1: {
        KKW: 300
      },
      corr_2: {
        KW: 30,
        KKW: 300
      },
      corr_3: {
        KW: 75,
        KKW: 405
      },
      corr_4: {
        KW: 230,
        KKW: 1285
      },
      corr_5: {
        KW: 700,
        KKW: 3720
      },
      corr_6: {
        KW: 1800,
        KKW: 8600
      }
    },
    m7: {
      corr_1: {
        KKW: 600
      },
      corr_2: {
        KW: 50,
        KKW: 600
      },
      corr_3: {
        KW: 130,
        KKW: 750
      },
      corr_4: {
        KW: 330,
        KKW: 1715
      },
      corr_5: {
        KW: 850,
        KKW: 4270
      },
      corr_6: {
        KW: 2000,
        KKW: 9300
      },
      corr_7: {
        KW: 4200,
        KKW: 17800
      }
    },
    m8: {
      corr_1: {
        KKW: 1050
      },
      corr_2: {
        KW: 75,
        KKW: 1050
      },
      corr_3: {
        KW: 200,
        KKW: 1250
      },
      corr_4: {
        KW: 460,
        KKW: 2310
      },
      corr_5: {
        KW: 1050,
        KKW: 5000
      },
      corr_6: {
        KW: 2275,
        KKW: 10200
      },
      corr_7: {
        KW: 4550,
        KKW: 18900
      },
      corr_8: {
        KW: 8400,
        KKW: 32200
      }
    },
    m9: {
      corr_1: {
        KKW: 1680
      },
      corr_2: {
        KW: 105,
        KKW: 1680
      },
      corr_3: {
        KW: 285,
        KKW: 1935
      },
      corr_4: {
        KW: 620,
        KKW: 3100
      },
      corr_5: {
        KW: 1300,
        KKW: 5940
      },
      corr_6: {
        KW: 2625,
        KKW: 11330
      },
      corr_7: {
        KW: 5005,
        KKW: 20255
      },
      corr_8: {
        KW: 8960,
        KKW: 33810
      },
      corr_9: {
        KW: 15120,
        KKW: 53200
      }
    },
    m10: {
      corr_1: {
        KKW: 2520
      },
      corr_2: {
        KW: 140,
        KKW: 2520
      },
      corr_3: {
        KW: 385,
        KKW: 2835
      },
      corr_4: {
        KW: 810,
        KKW: 4115
      },
      corr_5: {
        KW: 1600,
        KKW: 7120
      },
      corr_6: {
        KW: 3050,
        KKW: 12720
      },
      corr_7: {
        KW: 5565,
        KKW: 21895
      },
      corr_8: {
        KW: 9660,
        KKW: 35735
      },
      corr_9: {
        KW: 15960,
        KKW: 55440
      },
      corr_10: {
        KW: 25200,
        KKW: 82320
      }
    }
  },
  size_5: {
    m6: {
      corr_1: {
        KKW: 150
      },
      corr_2: {
        KKW: 90
      },
      corr_3: {
        KW: 15,
        KKW: 120
      },
      corr_4: {
        KW: 100,
        KKW: 395
      },
      corr_5: {
        KW: 1000,
        KKW: 3140
      },
      corr_6: {
        KW: 4800,
        KKW: 13300
      }
    },
    m7: {
      corr_1: {
        KKW: 450
      },
      corr_2: {
        KKW: 300
      },
      corr_3: {
        KW: 30,
        KKW: 330
      },
      corr_4: {
        KW: 180,
        KKW: 780
      },
      corr_5: {
        KW: 1250,
        KKW: 3980
      },
      corr_6: {
        KW: 5400,
        KKW: 15000
      },
      corr_7: {
        KW: 16800,
        KKW: 42300
      }
    },
    m8: {
      corr_1: {
        KKW: 1050
      },
      corr_2: {
        KKW: 750
      },
      corr_3: {
        KW: 50,
        KKW: 750
      },
      corr_4: {
        KW: 280,
        KKW: 1380
      },
      corr_5: {
        KW: 1550,
        KKW: 5080
      },
      corr_6: {
        KW: 6100,
        KKW: 17050
      },
      corr_7: {
        KW: 18200,
        KKW: 45900
      },
      corr_8: {
        KW: 44800,
        KKW: 104300
      }
    },
    m9: {
      corr_1: {
        KKW: 2100
      },
      corr_2: {
        KKW: 1575
      },
      corr_3: {
        KW: 75,
        KKW: 1500
      },
      corr_4: {
        KW: 400,
        KKW: 2300
      },
      corr_5: {
        KW: 1900,
        KKW: 6530
      },
      corr_6: {
        KW: 6900,
        KKW: 19525
      },
      corr_7: {
        KW: 19775,
        KKW: 50050
      },
      corr_8: {
        KW: 47600,
        KKW: 110950
      },
      corr_9: {
        KW: 100800,
        KKW: 219800
      }
    },
    m10: {
      corr_1: {
        KKW: 3780
      },
      corr_2: {
        KKW: 2940
      },
      corr_3: {
        KW: 105,
        KKW: 2730
      },
      corr_4: {
        KW: 540,
        KKW: 3675
      },
      corr_5: {
        KW: 2300,
        KKW: 8450
      },
      corr_6: {
        KW: 7800,
        KKW: 22530
      },
      corr_7: {
        KW: 21525,
        KKW: 54840
      },
      corr_8: {
        KW: 50680,
        KKW: 118405
      },
      corr_9: {
        KW: 105840,
        KKW: 231000
      },
      corr_10: {
        KW: 201600,
        KKW: 415800
      }
    }
  },
  size_6: {
    m7: {
      corr_1: {
        KKW: 180
      },
      corr_2: {
        KKW: 80
      },
      corr_3: {
        KW: 20,
        KKW: 80
      },
      corr_4: {
        KW: 65,
        KKW: 200
      },
      corr_5: {
        KW: 255,
        KKW: 815
      },
      corr_6: {
        KW: 2240,
        KKW: 11590
      },
      corr_7: {
        KW: 11900,
        KKW: 61700
      }
    },
    m8: {
      corr_1: {
        KKW: 630
      },
      corr_2: {
        KKW: 330
      },
      corr_3: {
        KW: 50,
        KKW: 280
      },
      corr_4: {
        KW: 170,
        KKW: 530
      },
      corr_5: {
        KW: 545,
        KKW: 1655
      },
      corr_6: {
        KW: 3005,
        KKW: 13755
      },
      corr_7: {
        KW: 13790,
        KKW: 66740
      },
      corr_8: {
        KW: 47600,
        KKW: 221900
      }
    },
    m9: {
      corr_1: {
        KKW: 1680
      },
      corr_2: {
        KKW: 980
      },
      corr_3: {
        KW: 100,
        KKW: 780
      },
      corr_4: {
        KW: 350,
        KKW: 1180
      },
      corr_5: {
        KW: 1010,
        KKW: 2970
      },
      corr_6: {
        KW: 4095,
        KKW: 16695
      },
      corr_7: {
        KW: 16205,
        KKW: 73005
      },
      corr_8: {
        KW: 52640,
        KKW: 234290
      },
      corr_9: {
        KW: 142800,
        KKW: 607600
      }
    },
    m10: {
      corr_1: {
        KKW: 3780
      },
      corr_2: {
        KKW: 2380
      },
      corr_3: {
        KW: 175,
        KKW: 1855
      },
      corr_4: {
        KW: 625,
        KKW: 2380
      },
      corr_5: {
        KW: 1700,
        KKW: 4980
      },
      corr_6: {
        KW: 5610,
        KKW: 20660
      },
      corr_7: {
        KW: 19320,
        KKW: 80820
      },
      corr_8: {
        KW: 58730,
        KKW: 248955
      },
      corr_9: {
        KW: 154140,
        KKW: 633640
      },
      corr_10: {
        KW: 357000,
        KKW: 1402800
      }
    }
  },
  size_7: {
    m8: {
      corr_1: {
        KKW: 210
      },
      corr_2: {
        KKW: 90
      },
      corr_3: {
        KKW: 70
      },
      corr_4: {
        KW: 20,
        KKW: 150
      },
      corr_5: {
        KW: 175,
        KKW: 575
      },
      corr_6: {
        KW: 1100,
        KKW: 2800
      },
      corr_7: {
        KW: 12800,
        KKW: 31400
      },
      corr_8: {
        KW: 80000,
        KKW: 185000
      }
    },
    m9: {
      corr_1: {
        KKW: 840
      },
      corr_2: {
        KKW: 420
      },
      corr_3: {
        KKW: 300
      },
      corr_4: {
        KW: 50,
        KKW: 480
      },
      corr_5: {
        KW: 400,
        KKW: 1460
      },
      corr_6: {
        KW: 2175,
        KKW: 5725
      },
      corr_7: {
        KW: 16650,
        KKW: 40350
      },
      corr_8: {
        KW: 91200,
        KKW: 208800
      },
      corr_9: {
        KW: 360000,
        KKW: 780000
      }
    },
    m10: {
      corr_1: {
        KKW: 2520
      },
      corr_2: {
        KKW: 1400
      },
      corr_3: {
        KKW: 980
      },
      corr_4: {
        KW: 100,
        KKW: 1260
      },
      corr_5: {
        KW: 750,
        KKW: 3090
      },
      corr_6: {
        KW: 3700,
        KKW: 10200
      },
      corr_7: {
        KW: 21725,
        KKW: 52525
      },
      corr_8: {
        KW: 105200,
        KKW: 238900
      },
      corr_9: {
        KW: 393600,
        KKW: 847200
      },
      corr_10: {
        KW: 1200000,
        KKW: 2460000
      }
    }
  },
  size_8: {
    m9: {
      corr_1: {
        KKW: 240
      },
      corr_2: {
        KKW: 100
      },
      corr_3: {
        KKW: 80
      },
      corr_4: {
        KW: 25,
        KKW: 105
      },
      corr_5: {
        KW: 85,
        KKW: 185
      },
      corr_6: {
        KW: 390,
        KKW: 1065
      },
      corr_7: {
        KW: 2700,
        KKW: 5900
      },
      corr_8: {
        KW: 53000,
        KKW: 145000
      },
      corr_9: {
        KW: 405000,
        KKW: 1085000
      }
    },
    m10: {
      corr_1: {
        KKW: 1080
      },
      corr_2: {
        KKW: 520
      },
      corr_3: {
        KKW: 380
      },
      corr_4: {
        KW: 75,
        KKW: 435
      },
      corr_5: {
        KW: 275,
        KKW: 685
      },
      corr_6: {
        KW: 1035,
        KKW: 2635
      },
      corr_7: {
        KW: 5415,
        KKW: 12240
      },
      corr_8: {
        KW: 63800,
        KKW: 167000
      },
      corr_9: {
        KW: 441000,
        KKW: 1149000
      },
      corr_10: {
        KW: 2025000,
        KKW: 5085000
      }
    }
  },
  size_9: {
    m10: {
      corr_1: {
        KKW: 270
      },
      corr_2: {
        KKW: 110
      },
      corr_3: {
        KKW: 90
      },
      corr_4: {
        KKW: 90
      },
      corr_5: {
        KW: 25,
        KKW: 115
      },
      corr_6: {
        KW: 230,
        KKW: 480
      },
      corr_7: {
        KW: 1100,
        KKW: 2150
      },
      corr_8: {
        KW: 12000,
        KKW: 23750
      },
      corr_9: {
        KW: 295000,
        KKW: 685000
      },
      corr_10: {
        KW: 2500000,
        KKW: 5650000
      }
    }
  }
};
if (svs.isServer) {
  module.exports = {
    keno,
    kenoSystem
  };
} else {
  svs.numbergames.rules.utils.keno_winplan.data = svs.numbergames.rules.utils.keno_winplan.data || {};
  svs.numbergames.rules.utils.keno_winplan.data.keno = keno;
  svs.numbergames.rules.utils.keno_winplan.data.kenoSystem = kenoSystem;
}

 })(window);